import { render, staticRenderFns } from "./UrlEmbed.vue?vue&type=template&id=76f0f7ea&"
import script from "./UrlEmbed.vue?vue&type=script&lang=js&"
export * from "./UrlEmbed.vue?vue&type=script&lang=js&"
import style0 from "./UrlEmbed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports